<template>
<div class="chapter">
<div class="inner_page">
<p class="half"><a id="page_xvii">PERFORMING TRAUMA IN CENTRAL AFRICA</a></p><a id="page_xvii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_Halftitle02.vue?73b8b18a